module.exports = __webpack_public_path__ + "static/media/p3_3.4097a251.png";